import { FC } from 'react';
import { ReactComponent as Logo } from 'atoms/icons/svg/remora-customer-logo.svg';
import { useTranslation } from 'react-i18next';
import SupportBtn from 'components/Support';
import './CustomerHeader.scss';
import SiteDropdown from 'components/Sites/Dropdown';

const CustomerHeader: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="customer-header">
      <div className="header-left">
        <div className="logo">
          <Logo />
        </div>
        <span className="portal">{t('Insight')}</span>
      </div>

      <div className="header-right">
        <span className="support">
          <SupportBtn />
        </span>
        <div className="divider" />
        <span className="site-selector">
          <SiteDropdown />
        </span>
      </div>
    </div>
  );
};

export default CustomerHeader;
